<template>
    <div class="dropdown-sortir m-0">
        <button
            class="btn btn-secondary dropdown-toggle font-weight-600 p-0"
            type="button"
            :id="id"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
        >
            {{ title }}
        </button>
        <div class="dropdown-menu item-wraper">
            <div
                class="dropdown-item"
                v-for="(item, i) in items"
                :key="i"
                :class="{ 'selected-filter': item.selected, 'f-c-blue': item.selected }"
                @click="action(item, i)"
            >
                {{ item.title }}
                <img v-if="item.selected" src="../../../assets/icons/checked-blue.svg" alt="" class="m-l-12" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SODropdown",
    props: {
        id: String,
        items: Array,
        title: String,
    },
    methods: {
        action(item, i) {
            let temp = JSON.parse(JSON.stringify(this.items));
            let selectedIndex = temp.findIndex((a) => a.selected === true);
            if (selectedIndex !== -1) {
                temp[selectedIndex].selected = false;
            }
            temp[i].selected = true;

            this.$emit("update-data", temp);
            this.$emit("action", item.action);
        },
    },
};
</script>

<style scoped>
.selected-filter {
    background-color: #e9f0ff;
}
.item-wraper {
    max-height: 200px;
    overflow: hidden;
    overflow-y: scroll;
}
</style>
